/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-procedure-episode.reducer';

export const PatientProcedureEpisodeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientProcedureEpisodeEntity = useAppSelector(state => state.patientProcedureEpisode.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientProcedureEpisodeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.detail.title">PatientProcedureEpisode</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.id}</dd>
          <dt>
            <span id="plannedStart">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.plannedStart">Planned Start</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.plannedStart}</dd>
          <dt>
            <span id="plannedEnd">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.plannedEnd">Planned End</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.plannedEnd}</dd>
          <dt>
            <span id="actualStart">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.actualStart">Actual Start</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.actualStart}</dd>
          <dt>
            <span id="actualEnd">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.actualEnd">Actual End</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.actualEnd}</dd>
          <dt>
            <span id="outcome">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.outcome">Outcome</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.outcome}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.notes}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.status">Status</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.status}</dd>
          <dt>
            <span id="statusReason">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.statusReason">Status Reason</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.statusReason}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{patientProcedureEpisodeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.procedure">Procedure</Translate>
          </dt>
          <dd>{patientProcedureEpisodeEntity.procedure ? patientProcedureEpisodeEntity.procedure.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.metaEpisode">Meta Episode</Translate>
          </dt>
          <dd>{patientProcedureEpisodeEntity.metaEpisode ? patientProcedureEpisodeEntity.metaEpisode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-procedure-episode" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-procedure-episode/${patientProcedureEpisodeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientProcedureEpisodeDetail;
